import * as Icons from 'lucide-react';
import type { Language } from './i18n';

export interface Service {
  id: string;
  title: string;
  subheadline: string;
  teaser: string;
  description: string;
  icon: React.ComponentType<any>;
  targetgroup: string;
}

export interface TargetGroup {
  key: string;
  label: string;
}

export interface ServicesData {
  targetgroups: TargetGroup[];
  services: Service[];
}

export async function getServices(language: Language): Promise<ServicesData> {
  try {
    const response = await fetch(`/content/services/${language}.json`);
    if (!response.ok) {
      throw new Error('Failed to load services');
    }
    const data = await response.json();
    
    // Map the icon strings to actual icon components
    const services = data.services.map((service: any) => ({
      ...service,
      icon: Icons[service.icon as keyof typeof Icons]
    }));

    return {
      targetgroups: data.targetgroups || [],
      services
    };
  } catch (error) {
    console.error('Error loading services:', error);
    return { targetgroups: [], services: [] };
  }
}